import { render, staticRenderFns } from "./TravauxDetails.vue?vue&type=template&id=e08ab880&"
import script from "./TravauxDetails.vue?vue&type=script&lang=js&"
export * from "./TravauxDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports